<template>
    <div class="main_agreement">
        <div class="main_agreement_page">
            <div class="navigation">
                <div class="left" @click="goBack"><i class="icon-thin_back"></i></div>
                <div class="content">用户协议</div>
            </div>
            <div class="agreement">本《软件使用及服务协议》（下称《协议》）是您（下称“用户”）与上海慧力信息技术有限公司（“慧力”“Smart Power”）之间关于用户安装、使用、复制慧力“小花生”手机软件（包括所有手机系统平台版本，下称“小花生”）；注册、使用、管理小花生账号；以及使用慧力相关服务所订立的协议。
                <br/><br/>
                用户应认真阅读并充分理解此《软件使用及服务协议》。请审慎阅读并选择接受或不接受本《协议》（未成年人应在法定监护人陪同下阅读）。用户的安装、使用、账号获取和登录等行为均被视为对本《协议》的接受，并同意接受各项条款的约束。
                <br/><br/>
                本《协议》可由慧力随时更新，更新后的协议条款一经公布，即时代替原来的协议条款，恕不再另行通知。用户可随时查阅最新版协议条款。在慧力修改《协议》条款后，用户继续使用“小花生”软件和服务将被视为已接受了修改后的协议。如果用户不接受修改后的条款，请立即停止使用。
                <br/><br/>
                使用“小花生”必须遵守国家有关法律和政策并遵守本《协议》。对于用户违法或违反本《协议》的使用而引起的一切责任，由用户负全部责任，一概与慧力及合作方无关。导致慧力及合作方损失的，慧力及合作方有权要求用户赔偿，并有权保留相关记录。
                <br/><br/>
                一、知识产权声明
                <br/><br/>
                1.1 “小花生”是由慧力开发，一切著作权、商标权、专利权、商业秘密等知识产权，以及相关的所有信息内容，包括但不限于：图标、图表、色彩、界面设计、版面框架、数据、电子文档等均受中华人民共和国著作权法、商标法、专利法、反不正当竞争法和相应的国际条约以及其他知识产权法律法规的保护，慧力享有上述知识产权。
                <br/><br/>
                1.2 未经慧力书面同意，用户不得以任何目的使用或转让上述知识产权，慧力保留追究上述未经许可行为的权利。
                <br/><br/>
                二、账号使用须知
                <br/><br/>
                2.1 “小花生”账号的所有权归慧力，用户完成注册后获得相应的使用权。用户承担“小花生”账号与密码的保管责任，并对所注册的账号及密码下的一切活动负全部责任。
                <br/><br/>
                2.2 用户的“小花生”账号在丢失或遗忘密码后，可以通过绑定过“小花生”账号的手机号进行登录密码重置。慧力只负责核对验证信息是否与账号相关信息一致，而不对信息提供者身份进行证实，不对冒名验证行为承担任何责任。同时，慧力不承诺通过账号相关的个人信息进行验证一定能找回账号。
                <br/><br/>
                2.3 用户不得实施包括但不限于下列行为：
                <br/><br/>
                通过非慧力开发、授权或认可的软件、插件、外挂等登录或使用“小花生”软件和服务
                <br/><br/>
                2.3.1 去除“小花生”中的版权信息；
                <br/><br/>
                2.3.2 对“小花生”进行反向工程、反向汇编、反向编译等；
                <br/><br/>
                2.3.3 使用“小花生”发表、传播、储存违反国家法律法规的内容：危害国家安全、祖国统一、社会稳定、公序良俗的内容，或任何不当的、侮辱诽谤的、淫秽的、暴力的及任何违反国家法律法规政策的内容。
                <br/><br/>
                三、“小花生”社区管理规定
                <br/><br/>
                "小花生"致力于提供一个由用户创造高质量内容、分享真实教育经验的社区。为了保护用户创造的内容、维护良好的社区氛围，"小花生"社区管理员将依据本协议和社区管理规定中的条款对注册小花生用户和发布在"小花生"的内容进行管理。采取的措施包括但不限于更改或删除用户发布的内容、暂停或终止用户使用"小花生"的权利。
                <br/><br/>
                所有有意的降低内容质量、伤害社区氛围的行为（下称「破坏」）都是不能容忍的。多数情况下社区中的其他用户会优先选择对破坏行为做出劝诫、建议和引导，"小花生"也会先发出警告并给予用户改正的机会，但不表示"小花生"在采取任何措施前必须首先发出警告。
                <br/><br/>
                违规行为：
                <br/><br/>
                3.1 不友善行为：
                <br/><br/>
                羞辱、谩骂、攻击"小花生"用户或其他不尊重"小花生"用户的内容；
                <br/><br/>
                臆测、羞辱、谩骂、攻击或其他不尊重"小花生"用户在"小花生"的日志、回答、评论的内容；
                <br/><br/>
                骚扰、恐吓、威胁、诽谤"小花生"用户，或者其他发布在"小花生"并对其他用户造成严重影响的内容;
                <br/><br/>
                恶意煽动小花生用户攻击、孤立或以其他手段不友善地对待其他用户的内容；
                <br/><br/>
                因民族、种族、宗教、性取向、性别、年龄、地域、生理特征等身份或者归类而歧视、侮辱、攻击他人的内容；
                <br/><br/>
                泄露他人隐私，或者其他侵犯他人合法权益的内容。
                <br/><br/>
                3.2 以推广曝光为目的，发布影响用户体验、扰乱"小花生"社区秩序的内容，或进行相关行为。
                <br/><br/>
                多次发布包含售卖产品、提供服务、宣传推广内容的垃圾广告。包括但不限于以下几种形式：<br/>
                单个账号多次发布包含垃圾广告的内容；
                <br/><br/>
                多个广告账号互相配合发布包含垃圾广告的内容；
                <br/><br/>
                多次发布包含欺骗性外链的内容，如未注明的淘宝客链接、跳转网站等，诱骗用户点击链接；<br/>
                发布大量包含 SEO 推广链接、产品、品牌等内容获取搜索引擎中的不正当曝光；
                <br/><br/>
                购买或出售账号之间虚假地互动，发布干扰社区秩序的推广内容及相关交易。包括但不限于以下几种形式：
                <br/><br/>
                购买机器注册账号，或人工操控账号的关注，伪造在社区内的影响力；
                <br/><br/>
                购买机器注册账号，或人工操控账号点击赞同，谋求回答的不正当曝光；
                <br/><br/>
                使用机器、恶意程序手段或人为有组织性地操控账号进行点赞、回答等扰乱秩序的行为；
                <br/><br/>
                使用严重影响用户体验的违规手段进行恶意营销。包括但不限于以下几种形式：
                <br/><br/>
                不规范转载或大篇幅转载他人内容同时加入推广营销内容；
                <br/><br/>
                发布包含欺骗性的恶意营销内容，如通过伪造经历、冒充他人等方式进行恶意营销；
                <br/><br/>
                使用特殊符号、图片等方式规避垃圾广告内容审核的广告内容；
                <br/><br/>
                恶意注册使用"小花生"账号，包括但不限于机器注册、频繁注册、批量注册、滥用多个"小花生"账号。
                <br/><br/>
                3.3 恶意行为：滥用产品功能，进行影响用户体验，危及平台安全及损害他人权益的行为。主要表现为：
                <br/><br/>
                冒充他人，通过头像、用户名等个人信息暗示自己与他人或机构相等同或有关联。
                <br/><br/>
                重复发布干扰正常用户体验的内容。包括但不限于以下几种形式：
                <br/><br/>
                重复的回答内容多次发布在不同问题下；
                <br/><br/>
                频繁发布难以辨识涵义影响阅读体验的字符、数字等无意义乱码；
                <br/><br/>
                骚扰他人，以评论、@他人、私信等方式对他人反复发送重复或者相似的诉求；
                <br/><br/>
                诱导投票或关注，如通过点赞抽奖、集赞更新等形式诱导投票或者诱导关注；
                <br/><br/>
                制作及传播外挂或者用于操作账号功能的恶意程序或相关教程；
                <br/><br/>
                发布含有潜在危险的内容，或使用第三方网站伪造跳转链接，如钓鱼网站、木马、病毒网站等。<br/>
                恶意对抗行为，包括但不限于使用变体、谐音等方式规避安全审查，明知相关行为违反法律法规和社区规范仍然多次发布等。
                <br/><br/>
                3.4 以任何不合法的方式、为任何不合法的目的、或以任何与本协议不一致的方式使用本软件和和慧力提供的其它服务。
                <br/><br/>
                四、隐私保护
                <br/><br/>
                4.1 个人隐私信息指可以用于对用户进行个人辨识或涉及个人通信的信息，包括：IP地址，电子邮件地址，以及用户在参与慧力及合作方发起的特定活动时填写的姓名、身份证号、手机号码、联系地址。非个人隐私信息指用户在使用“小花生”时的操作状态、设备信息以及使用习惯等明确客观记录在慧力服务器端的基本记录信息，和其他一切个人隐私信息范围外的普通信息。
                <br/><br/>
                4.2 用户若参与慧力及合作方发起的特定活动，需要向慧力及合作方提供特定的个人隐私信息，慧力及合作方不得向任何其它组织、单位和个人公开、透露相关信息。
                <br/><br/>
                4.3 慧力会采取合理的措施保护用户的个人隐私信息，除法律或有法律赋予权限的政府部门要求或用户同意等原因外，慧力未经用户同意不向第三方公开、透露用户个人隐私信息。
                <br/><br/>
                4.4 为了改善慧力的技术和服务，我们将可能会收集、使用用户的非个人隐私信息，以提供更好的用户体验和服务质量。
                <br/><br/>
                4.5 用户的日历记录会被自动上传至慧力服务器，在用户使用“小花生”账号时，可以通过慧力服务器自动备份和恢复日历记录。但是 小花生 不保证在任何情况下完整永久地保存所有用户数据。
                <br/><br/>
                4.6 用户的日历记录在与个人隐私信息解除关联的前提下，可能用于统计运算。
                <br/><br/>
                四、知识产权
                <br/><br/>
                4.1 用户在"小花生"上发表的全部原创内容（包括但不仅限于回答、日志和评论），著作权均归用户本人所有。用户可授权第三方以任何方式使用，不需要得到小花生的同意。
                <br/><br/>
                4.2 "小花生"提供的的网络服务中包含的标识、版面设计、排版方式、文本、图片、图形等均受著作权、商标权及其它法律保护，未经相关权利人（含“小花生”及其他原始权利人）同意，上述内容均不得在任何平台被直接或间接发布、使用、出于发布或使用目的的改写或再发行，或被用于其他任何商业目的。
                <br/><br/>
                4.3 为了促进知识的分享和传播，用户将其在"小花生"上发表的全部内容，授予小花生免费的、不可撤销的、非独家使用许可，"小花生"有权将该内容用于慧力各种形态的产品和服务上，包括但不限于网站以及发表的应用或其他互联网产品。
                <br/><br/>
                4.4 第三方若出于非商业目的，将用户在"小花生"上发表的内容转载在"小花生"之外的地方，应当在作品的正文开头的显著位置注明原作者姓名（或原作者在小花生上使用的账号名称），给出原始链接，注明「发布于小花生网」，并不得对作品进行修改演绎。若需要对作品进行修改，或用于商业目的，第三方应当联系用户获得单独授权，按照用户规定的方式使用该内容。
                <br/><br/>
                4.5 "小花生"为用户提供「保留所有权利，禁止转载」的选项。除非获得原作者的单独授权，任何第三方不得转载标注了「禁止转载」的内容，否则均视为侵权。
                <br/><br/>
                4.6 在"小花生"上传或发表的内容，用户应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益。如果第三方提出关于著作权的异议，"小花生"有权根据实际情况删除相关的内容，且有权追究用户的法律责任。给慧力或任何第三方造成损失的，用户应负责全额赔偿。
                <br/><br/>
                4.7 如果任何第三方侵犯了“小花”生用户相关的权利，用户同意授权慧力或其指定的代理人代”小花生“乎自身或用户对该第三方提出警告、投诉、发起行政执法、诉讼、进行上诉，或谈判和解，并且用户同意在小花生认为必要的情况下参与共同维权。
                <br/><br/>
                4.8 “小花生”有权但无义务对用户发布的内容进行审核，有权根据相关证据结合《侵权责任法》、《信息网络传播权保护条例》等法律法规及”小花生“社区指导原则对侵权信息进行处理。
                <br/><br/>
                五、法律责任与免责申明
                <br/><br/>
                5.1 慧力将会尽其商业上的合理努力以保护用户的设备资源及通讯的隐私性和完整性，但是，用户承认和同意慧力不能就此事提供任何保证。
                <br/><br/>
                5.2 慧力可以根据用户的使用状态和行为，为了改进“小花生”的功能、用户体验和服务，开发或调整软件功能。
                <br/><br/>
                5.3 慧力为保障业务发展和调整的自主权，有权随时自行修改或中断软件服务而不需通知用户。
                <br/><br/>
                5.4 在任何情况下因使用或不能使用本“小花生”所产生的直接、间接、偶然、特殊及后续的损害及风险，慧力及合作方不承担任何责任。
                <br/><br/>
                5.5 慧力有权在“小花生”中投放不同形式的广告信息。
                <br/><br/>
                5.6 因技术故障等不可抗事件影响到服务的正常运行的，慧力及合作方承诺在第一时间内与相关单位配合，及时处理进行修复，但用户因此而遭受的一切损失，慧力及合作方不承担责任。
                <br/><br/>
                5.7 用户通过“小花生”与其他用户联系，因受误导或欺骗而导致或可能导致的任何心理、生理上的伤害以及经济上的损失，由过错方依法承担所有责任，一概与慧力及合作方无关。
                <br/><br/>
                5.8 用户若通过非慧力官方网站，或非慧力授权网站下载的“小花生”，将可能导致不可预知的风险，由此产生的一切法律责任与纠纷一概与慧力无关。
                <br/><br/>
                本协议中未声明地其它一切权利，归慧力所有。慧力保留对本协议的最终解释权利。<br/><br/></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "UserAgreement",
        methods:{
            goBack:function () {
                let that = this;
                that.$router.go(-1);
            }
        }
    }
</script>

<style scoped>
    .main_agreement {
        position:absolute;
        width:100%;
        height:auto;
        min-height: 100%;
        text-align: left;
    }
    .agreement {
        font-size:12pt;
        color:#333333;
        padding: 64px 20px 20px 20px;
    }
    .main_agreement_page {
        max-width: 590px;
        word-wrap: break-word;
        word-break: normal;
        margin: 0px auto;
        text-align: left;
        background-color: white;
    }
    .navigation {
        position: fixed;
        width: 100%;
        height: 44px;
        border-bottom: 1px solid #E5E3E3;
        background-color: white;
        max-width: 590px;
    }
    .navigation .left {
        float: left;
        width: 50px;
        height: 100%;
        color: #333333;
        font-size: 20px;
        text-align: center;
        line-height: 50px;
    }
    .navigation .content {
        float: left;
        height: 100%;
        width: calc(100% - 50px - 15px);
        text-align: center;
        line-height: 44px;
        color: #333333;
        font-size: 18px;
        font-weight: bold;
    }
</style>
